import { action } from 'satcheljs';
import { LayoutMode } from '../store/schema';

export const onLayoutChanged = action('onLayoutChanged', (layout: LayoutMode) => ({ layout }));
